var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"word_list flex"},_vm._l((_vm.list),function(item,index){return (_vm.$route.meta != item.title)?_c('li',{key:index,on:{"click":function($event){return _vm.routePush(item.id)}}},[_c('img',{attrs:{"src":item.imgUrl,"alt":""}}),_c('p',[_vm._v(_vm._s(item.title))])]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }